import { NextPage } from "next";
import { GetServerSideProps } from 'next';
import { CountryCode } from '@/lib/constants';
import blogService from '@/lib/services/blogService';
import {  Justin, TopAuthors, TrendsBanner } from "@/components/trends";
import { IBlogAuthor, IJustIn, IMetaHead, IPageMenu, ITrendsCategory } from "@/interfaces";
import { TrendsCategory } from "@/components/trends/trendsCategory";
import { MetaHead } from "@/components/shared/metaHead";
import { BreadCrumb } from "@/components/shared/breadCrumb";
import { SchemaHead } from "@/components/shared/schemaHead";

type Props = {
  data: ITrendsCategory
  categorySlug: string
  JustinData:IJustIn[]
  authors:IBlogAuthor[]
  navSchemaData:IPageMenu[]
}
const Category: NextPage<Props> = ({ data, categorySlug ,JustinData,authors,navSchemaData}) => {
  const metaData: IMetaHead = {
    title: `${data?.meta_title}`,
    description: `${data?.meta_description}`,
    hreflangNotRequired:true,
    ogImage:`${process.env.CMS_CDN_URL}/${data.sub_cat_data[0].posts[0].post_relative}`
  };
  return (
    <>
      <MetaHead metaData={metaData} />
      <BreadCrumb />
      <SchemaHead navSchemaData={navSchemaData} />
      <TrendsBanner h1text={data && data.banner_text_h1} h2text={data && data.banner_text_h2} />
      <TrendsCategory data={data} countryCode={CountryCode.INR} categorySlug={categorySlug} />
      <Justin JustinData={JustinData} countryCode={CountryCode.INR}/> 
      <TopAuthors authors={authors} countryCode={CountryCode.INR} />
      </>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const categorySlug = context.params?.category?.toString() || "";
  const data = (await blogService.getTrendsCategory(CountryCode.INR, categorySlug)) || "";
  const JustinData = (await blogService.getJustInData(CountryCode.INR)) || {};
  const authors=await blogService.getAuthors(CountryCode.INR);
  if (!data || data.length == 0 || !data.parent_cat ||!JustinData || !data.sub_cats || JustinData.length == 0 || !authors || authors.length == 0)
   return { notFound: true }
  return {
    props: { data, categorySlug ,JustinData,authors},
  }
}
export default Category;